import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line max-classes-per-file -- directive added automatically by Shepherd migration
import React from 'react';
import PropTypes from 'prop-types';
import goToAnchor from './go-to-anchor'; // this module uses two Contexts internally.
// the first Context is to provide a default consumer handler
// and to allow that default to be overridden from above

var AnchorContext = /*#__PURE__*/React.createContext({
  onAnchorClick: goToAnchor
}); // the second Context is to hold on to the bound handlers
// and provide them to consumers of this modules Context

var AnchorHandlersContext = /*#__PURE__*/React.createContext({
  handleTargetRef: function handleTargetRef() {},
  handleAnchorClick: function handleAnchorClick() {},
  // Provides a means for components to get the ref of a given anchor link target.
  // Used within TableOfContents, for example.
  getTargetRef: function getTargetRef() {}
});

var AnchorContextProviderImpl = /*#__PURE__*/function (_React$Component) {
  _inherits(AnchorContextProviderImpl, _React$Component);

  var _super = _createSuper(AnchorContextProviderImpl);

  function AnchorContextProviderImpl(props) {
    var _this;

    _classCallCheck(this, AnchorContextProviderImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getTargetRef", function (target) {
      return _this.props.targetMap.get(target);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTargetRef", function (ref, target) {
      if (!process.browser) return;
      var targetMap = _this.props.targetMap;
      if (!ref) return targetMap["delete"](target); // don't overwrite current targets

      if (targetMap.get(target)) return; // store the target

      targetMap.set(target, ref);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAnchorClick", function (_ref, e) {
      var target = _ref.target,
          behavior = _ref.behavior;
      var onAnchorClick = _this.props.onAnchorClick;
      if (!onAnchorClick) return;
      var targetMap = _this.props.targetMap;
      var ref = targetMap.get(target);
      if (!ref) return;
      e === null || e === void 0 ? void 0 : e.preventDefault();
      onAnchorClick({
        target: target,
        elem: ref,
        behavior: behavior
      });
    });

    var _assertThisInitialize = _assertThisInitialized(_this),
        handleTargetRef = _assertThisInitialize.handleTargetRef,
        handleAnchorClick = _assertThisInitialize.handleAnchorClick,
        getTargetRef = _assertThisInitialize.getTargetRef;

    _this.state = {
      anchorHandlersContextValue: {
        onTargetRef: handleTargetRef,
        onAnchorClick: handleAnchorClick,
        getTargetRef: getTargetRef
      }
    };
    return _this;
  }

  _createClass(AnchorContextProviderImpl, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          anchorContextValue = _this$state.anchorContextValue,
          anchorHandlersContextValue = _this$state.anchorHandlersContextValue; // first re-provide the `onAnchorClick` handler to child contexts
      // then provide the handlers that used `onAnchorClick`
      // bound to this instance's ref Map()

      return /*#__PURE__*/React.createElement(AnchorContext.Provider, {
        value: anchorContextValue
      }, /*#__PURE__*/React.createElement(AnchorHandlersContext.Provider, {
        value: anchorHandlersContextValue
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var onAnchorClick = nextProps.onAnchorClick,
          targetMap = nextProps.targetMap;
      var _prevState$prevProps = prevState.prevProps,
          prevProps = _prevState$prevProps === void 0 ? {} : _prevState$prevProps;

      if (onAnchorClick === prevProps.onAnchorClick && targetMap === prevProps.targetMap) {
        return null;
      }

      return {
        prevProps: nextProps,
        anchorContextValue: {
          onAnchorClick: onAnchorClick,
          targetMap: targetMap
        }
      };
    } // eslint-disable-next-line react/destructuring-assignment

  }]);

  return AnchorContextProviderImpl;
}(React.Component);
/**
 * Provides a context to [`AnchorLink`](./AnchorLink.md) and [`AnchorLinkContext`](./AnchorLinkContext.md). It's mandatory
 * to wrap this component around any uses of those components in a document.
 */


_defineProperty(AnchorContextProviderImpl, "propTypes", {
  children: PropTypes.node.isRequired,
  onAnchorClick: PropTypes.func.isRequired,
  targetMap: PropTypes.instanceOf(Map).isRequired
});

var AnchorContextProvider = /*#__PURE__*/function (_React$Component2) {
  _inherits(AnchorContextProvider, _React$Component2);

  var _super2 = _createSuper(AnchorContextProvider);

  // eslint-disable-line prettier/prettier
  function AnchorContextProvider(props) {
    var _this2;

    _classCallCheck(this, AnchorContextProvider);

    _this2 = _super2.call(this, props); // create a new targetMap to supply child context consumers
    // when targetMap doesn't exist in current context

    _this2.targetMap = new Map();
    return _this2;
  }

  _createClass(AnchorContextProvider, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          onAnchorClick = _this$props.onAnchorClick,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(AnchorContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(AnchorContextProviderImpl // use default `onAnchorClick` from context if prop not defined
        , {
          onAnchorClick: onAnchorClick || ctx.onAnchorClick // supply targetMap from context if present,
          ,
          targetMap: ctx.targetMap || _this3.targetMap
        }, children);
      });
    }
  }]);

  return AnchorContextProvider;
}(React.Component);

_defineProperty(AnchorContextProvider, "propTypes", {
  children: PropTypes.node.isRequired,
  onAnchorClick: PropTypes.func // eslint-disable-line react/require-default-props

});

_defineProperty(AnchorContextProvider, "defaultProps", {});

export { AnchorContextProvider };
export default AnchorHandlersContext;